export default {
  content: state => state.content,
  status: state => state.status,
  loaded: state => state.status === "loaded"
};
